import { useIntl } from '@atlassian/jira-intl';
import {
	type MenuNode,
	MenuNodeType,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import type { CardId } from '../../../../../../model/types.tsx';
import { useSimplyMoveCards } from '../../../../../../state/state-hooks/use-simply-move-cards/index.tsx';
import { RANK_MENU_DOWN_ID, RANK_MENU_UP_ID } from '../../constants.tsx';
import messages from '../../messages.tsx';

/**
 * Menu items for ranking issues up and down their current position.
 */
export function useRankIssueItems({ issueId }: { issueId: CardId }): MenuNode[] {
	const { formatMessage } = useIntl();
	const moveCards = useSimplyMoveCards();

	const onClick = (type: 'rank-up' | 'rank-down') => {
		moveCards({
			source: {
				cardId: issueId,
			},
			location: {
				type,
			},
		});
	};
	const onClickRankUp = () => onClick('rank-up');
	const onClickRankDown = () => onClick('rank-down');

	return [
		{
			type: MenuNodeType.Item,
			id: RANK_MENU_UP_ID,
			label: formatMessage(messages.rankUp),
			onClick: onClickRankUp,
		},
		{
			type: MenuNodeType.Item,
			id: RANK_MENU_DOWN_ID,
			label: formatMessage(messages.rankDown),
			onClick: onClickRankDown,
		},
	];
}
